import { render, staticRenderFns } from "./DevFooter.vue?vue&type=template&id=53bfef58&scoped=true"
var script = {}
import style0 from "./DevFooter.vue?vue&type=style&index=0&id=53bfef58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfef58",
  null
  
)

export default component.exports